'use client';

import { isMobileDevice } from '@/shared/lib/device';
import { VS_URL } from '@/shared/model/constants/url';

interface BreakpointRedirectProps {
  children: React.ReactNode;
  isMobileComponent?: boolean;
}

const BREAK_POINT = 1280;

const DeviceRouter = ({ children, isMobileComponent }: BreakpointRedirectProps) => {
  if (typeof window === 'undefined') return children;
  if (window.location.host.includes('local')) return children;

  const innerWidth = window.innerWidth;
  const userAgent = window.navigator.userAgent;
  const isBot = /bot|crawl|spider|slurp/i.test(userAgent);

  // SEO 목적의 봇은 렌더링 처리
  if (isBot) return children;

  // 쿠키 내 유저 DEVICE 정보 설정
  document.cookie = `VS_USER_DEVICE=${innerWidth < BREAK_POINT ? 'MO' : 'PC'}; path=/; domain=${process.env.NEXT_PUBLIC_TOP_DOMAIN}; max-age=31536000`;

  // PC 기기에서 PC 컴포넌트로 진입했는데 break point(1280) 미만인 경우 모바일로 리디렉션
  if (!isMobileDevice(userAgent) && !isMobileComponent && innerWidth < BREAK_POINT) {
    window.location.href = VS_URL.MOBILE_DOMAIN;
    return null;
  }

  // PC 기기에서 MO 컴포넌트로 진입했는데 break point(1280) 이상인 경우 PC로 리디렉션
  if (!isMobileDevice(userAgent) && isMobileComponent && innerWidth > BREAK_POINT) {
    window.location.href = VS_URL.PC_DOMAIN;
    return null;
  }

  return children;
};

export default DeviceRouter;
